import camelize from 'camelcase-keys-deep';
import camelCase from 'lodash.camelcase';
import { createReducer } from 'redux-create-reducer';
import {
  CERTIFICATION_OPTION_TOGGLED,
  GROUP_FETCHED,
  GROUP_FETCHED_ERRORED,
  GROUP_FETCHED_INACTIVE,
  GROUP_FETCHING,
  UPDATE_REQUEST_FIELD,
  UPDATE_SERVICE_OPTIONS,
  SELECT_SERVICE_OPTION,
  CUSTOMER_DETAILS_FETCHED,
  DISCLAIMER_FETCHED,
  DISCLAIMER_FETCHED_ERROR,
  DISCLAIMER_FETCHING,
} from '../actions';

const initialState = {
  accountLogo: '',
  addresses: [],
  certificationOptions: [],
  collectImei: false,
  configurableFields: [],
  disableAltTimes: false,
  groupPays: false,
  id: '',
  imeiRequired: false,
  logo: '',
  loading: false,
  name: 'Consumer',
  requestFields: [],
  slug: '',
  serviceOptions: [],
  cancellationWindow: '',
  allowSubmit: true,
  hasActiveProtectionPlan: false,
  assurantIneligibleRepair: false,
  disclaimer: null,
};
const events = {
  [CERTIFICATION_OPTION_TOGGLED]: (state, { id }) => {
    const { certificationOptions } = state;

    const updatedOptions = certificationOptions.map(option =>
      option.id === id ? { ...option, value: !option.value } : option
    );

    return { ...state, certificationOptions: updatedOptions };
  },

  [GROUP_FETCHED]: (
    state,
    {
      group: {
        id,
        account_logo,
        account_alternate_logo,
        account_name,
        addresses = [],
        certification_options = [],
        collect_imei = false,
        configurable_fields = [],
        group_pays_incident_fee,
        imei_required = false,
        logo,
        alternate_logo,
        request_fields = [],
        slug,
        disableAltTimes,
        cancellation_window_in_hours = '',
      },
    }
  ) => ({
    ...state,
    id,
    accountLogo: account_logo,
    accountAlternateLogo: account_alternate_logo,
    addresses: addresses.map(camelize),
    certificationOptions: certification_options.map(option => ({
      ...camelize(option),
      value: false,
    })),
    collectImei: collect_imei,
    configurableFields: configurable_fields.map(option => ({
      ...camelize(option),
      columnName: camelCase(option.column_name),
    })),
    disableAltTimes,
    groupPays: group_pays_incident_fee,
    imeiRequired: imei_required,
    logo,
    alternateLogo: alternate_logo,
    loading: false,
    name: account_name,
    requestFields: request_fields,
    slug,
    cancellationWindow: cancellation_window_in_hours,
  }),

  [GROUP_FETCHED_INACTIVE]: (
    state,
    {
      group: {
        id,
        account_logo,
        account_alternate_logo,
        account_name,
        addresses = [],
        certification_options = [],
        collect_imei = false,
        configurable_fields = [],
        group_pays_incident_fee,
        imei_required = false,
        logo,
        alternate_logo,
        request_fields = [],
        slug,
        disableAltTimes,
        cancellation_window_in_hours = '',
      },
    }
  ) => ({
    ...state,
    id,
    accountLogo: account_logo,
    accountAlternateLogo: account_alternate_logo,
    addresses: addresses.map(camelize),
    certificationOptions: certification_options.map(option => ({
      ...camelize(option),
      value: false,
    })),
    collectImei: collect_imei,
    configurableFields: configurable_fields.map(option => ({
      ...camelize(option),
      columnName: camelCase(option.column_name),
    })),
    disableAltTimes,
    groupPays: group_pays_incident_fee,
    imeiRequired: imei_required,
    logo,
    alternateLogo: alternate_logo,
    loading: false,
    name: account_name,
    requestFields: request_fields,
    slug,
    cancellationWindow: cancellation_window_in_hours,
  }),

  [GROUP_FETCHED_ERRORED]: () => initialState,

  [GROUP_FETCHING]: state => ({ ...state, loading: true }),

  [UPDATE_REQUEST_FIELD]: (state, { name, value }) => {
    const newRequestFields = state.requestFields.map(field =>
      field.name === name ? { ...field, value } : field
    );

    return { ...state, requestFields: newRequestFields };
  },

  [UPDATE_SERVICE_OPTIONS]: (state, { options, offerLookupTable }) => {
    return {
      ...state,
      serviceOptions: [...options],
      offerLookupTable,
    };
  },

  [SELECT_SERVICE_OPTION]: (state, { serviceOption }) => {
    return { ...state, disableAltTimes: serviceOption === 'IN_STORE' };
  },

  [CUSTOMER_DETAILS_FETCHED]: (
    state,
    { allowSubmit, hasActiveProtectionPlan, assurantIneligibleRepair, groupId }
  ) => {
    return {
      ...state,
      allowSubmit,
      hasActiveProtectionPlan,
      assurantIneligibleRepair,
      id: groupId,
    };
  },

  [DISCLAIMER_FETCHED]: (state, { disclaimer }) => {
    return { ...state, disclaimer, loading: false };
  },

  [DISCLAIMER_FETCHED_ERROR]: state => {
    return { ...state, disclaimer: null, loading: false };
  },

  [DISCLAIMER_FETCHING]: state => {
    return { ...state, loading: true };
  },
};

export default createReducer(initialState, events);
